import axios from "axios";
let basurl = window.location.hostname;
const API_URL = `https://${basurl}`;

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0"; // Only for development!

export const visaApi = {
  getVisaRecords: async (params) => {
    try {
      const response = await axiosInstance.get("/api/VisaAPI/getVisaRecords", { params });
      return response.data?.result;
    } catch (error) {
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      throw error;
    }
  },

  saveVisaRecord: async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/VisaAPI/saveVisaRecord`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error saving visa record:", error);
      throw error;
    }
  },

  sendEmailToDeveloper: async (data) => {
    const response = await axiosInstance.post("/api/VisaAPI/sendEmailToDeveloper", data);
    return response.data;
  },
  unSubscribeFromEmailing: async (data) => {
    const response = await axiosInstance.post("/api/VisaAPI/unSubscribeFromEmailingAPI", data);
    return response.data;
  },
};

export default visaApi;
